import { geofenceStrategy } from './geofenceStrategy';
import * as meshbot from 'constants/MeshbotConstant';

/**
 * Strategy map for updating "when" blocks based on node type.
 */
export const strategyMap = {
    [meshbot.MESHBOT_NODE_TYPES.GEOFENCE]: geofenceStrategy,
};
